export let modalOptions = {
	wrapperId: '',
	contentId: '',
	content: '',
};

export const setter = (props) => {
	modalOptions = {
		...modalOptions,
		...props,
	};
};
